import { takeEvery, put, fork, all } from 'redux-saga/effects';
import { catalogueReducerActions, catalogueReducerCallTypes } from "..";


export function* onSelectServiceStartAsync({payload}){

    try{
        
        yield put(catalogueReducerActions.startCall({ callType: catalogueReducerCallTypes.select }));

        const service = payload.service;

        yield put(catalogueReducerActions.selectedService({ service }));
    }
    catch(error){

        yield put(catalogueReducerActions.catchError({
            callType: catalogueReducerCallTypes.select,
            error: "There was an error with the selected payment service."
        }));

    }

};

export function* onSelectServiceItemStartAsync({payload}){

    try{
        
        yield put(catalogueReducerActions.startCall({ callType: catalogueReducerCallTypes.select }));

        const serviceItem = payload.serviceItem;

        yield put(catalogueReducerActions.selectedServiceItem({ serviceItem }));
    }
    catch(error){

        yield put(catalogueReducerActions.catchError({
            callType: catalogueReducerCallTypes.select,
            error: "There was an error with the selected payment service item."
        }));

    }

};

export function* onSelectDepartmentStartAsync({payload}){

    try{
        
        yield put(catalogueReducerActions.startCall({ callType: catalogueReducerCallTypes.select }));

        const dept = payload.dept;

        yield put(catalogueReducerActions.selectedDept({ dept }));
    }
    catch(error){

        yield put(catalogueReducerActions.catchError({
            callType: catalogueReducerCallTypes.select,
            error: "There was an error with the selected department."
        }));

    }

};

export function* onResetStartAsync(){

    try{
        
        yield put(catalogueReducerActions.startCall({ callType: catalogueReducerCallTypes.action }));


        yield put(catalogueReducerActions.resetState());
    }
    catch(error){

        yield put(catalogueReducerActions.catchError({
            callType: catalogueReducerCallTypes.select,
            error: "There was an error when reloading the payment form."
        }));

    }

};

export function* onSelectProvinceStartAsync({payload}){

    try{
        
        yield put(catalogueReducerActions.startCall({ callType: catalogueReducerCallTypes.select }));

        const province = payload.province;

        yield put(catalogueReducerActions.selectedProv({ province }));
    }
    catch(error){

        yield put(catalogueReducerActions.catchError({
            callType: catalogueReducerCallTypes.select,
            error: "There was an error with the selected province."
        }));

    }

};

export function* onSelectRegionStartAsync({payload}){

    try{
        
        yield put(catalogueReducerActions.startCall({ callType: catalogueReducerCallTypes.select }));

        const region = payload.region;

        yield put(catalogueReducerActions.selectedRegion({ region }));
    }
    catch(error){

        yield put(catalogueReducerActions.catchError({
            callType: catalogueReducerCallTypes.select,
            error: "There was an error with the selected region."
        }));

    }

};


export const actionTypes = {
    SetDept: "[Set Department] Action",
    SetService: "[Set Service] Action",
    SetServiceItem: "[Set Service Item] Action",
    SetProvince: "[Set Province] Action",
    SetRegion: "[Set Region] Action",
    Reset: "[Reset State] Reset State Action"
};

export const actions = {

    setDept: (dept) => ({ type: actionTypes.SetDept, payload: { dept }}),
    setService: (service) => ({ type: actionTypes.SetService, payload: { service }}),
    setSerivceItem: (serviceItem) => ({ type: actionTypes.SetServiceItem, payload: { serviceItem }}),
    setProvince: (province) => ({ type: actionTypes.SetProvince, payload: { province }}),
    setRegion: (region) => ({ type: actionTypes.SetRegion, payload: { region }}),
    reset: () => ({ type: actionTypes.Reset, payload: { undefined } })

};

export function* setDept(){

    yield takeEvery(actionTypes.SetDept, onSelectDepartmentStartAsync);
};

export function* setProvince(){

    yield takeEvery(actionTypes.SetProvince, onSelectProvinceStartAsync);
};

export function* setRegion(){

    yield takeEvery(actionTypes.SetRegion, onSelectRegionStartAsync);
};

export function* setService(){
    
    yield takeEvery(actionTypes.SetService, onSelectServiceStartAsync);
};

export function* setServiceItem(){
    
    yield takeEvery(actionTypes.SetServiceItem, onSelectServiceItemStartAsync);
};

export function* reset(){
    
    yield takeEvery(actionTypes.Reset, onResetStartAsync);
};

const catalogueSagas = [
    fork(setDept),
    fork(setProvince),
    fork(setService),
    fork(setServiceItem),
    fork(reset),
    fork(setRegion),
];

export function* saga(){
    yield all ([...catalogueSagas]);
};